import React from 'react';
import { Modal } from 'react-bootstrap';
import $ from 'jquery';
import Utility from '../utilities/utility';
import CurrencyService from '../services/currency';

class CreateCustomerOrderModal extends React.Component {

    constructor(props) {
        super(props);

        this.currencyService = new CurrencyService();

        this.state = {
            currencies: []
        };
    }

    componentDidMount() {
        this.currencyList();
    }

    currencyList = async () => {
        try {
            const response = await this.currencyService.currencyList();

            if (response.ok) {
                this.setState({
                    currencies: await response.json()
                });
            }
        } catch (error) {
            console.log(error);
        }
    }

    createOrder = () => {
        let description = $('#orderDescription').val();
        let currencyId = $('#currencyId').val();

        if (Utility.isEmpty(description)) {
            Utility.showAlertWithId(
                'create-order-message',
                'Entrer la description',
                'danger',
                true
            );
            return;
        }

        if (Utility.isEmpty(currencyId)) {
            Utility.showAlertWithId(
                'create-order-message',
                'Choisir la devise',
                'danger',
                true
            );
            return;
        }

        this.props.onCreate({
            description: description,
            currencyId: currencyId,
            customerId: this.props.customer.customerId
        });
    }

    render() {
        const { show, onClose, customer } = this.props;

        return (
            <Modal show={show} onHide={onClose}>
                <Modal.Header closeButton>
                    Créer une Commande
                </Modal.Header>

                <Modal.Body>
                    <div id="create-order-message"></div>

                    {customer &&
                        <div className="alert alert-info">
                            Client: <strong>{customer.name}</strong>
                        </div>
                    }

                    <div className="form-group">
                        <label>Description</label>
                        <textarea
                            className="form-control"
                            id="orderDescription"
                            placeholder="Description de la commande"
                            rows={5}
                        ></textarea>
                    </div>

                    <div className="form-group">
                        <label>Devise</label>
                        <select className="form-control" id="currencyId">
                            <option></option>

                            {this.state.currencies.map(currency =>
                                <option
                                    key={currency.currencyId}
                                    value={currency.currencyId}
                                >
                                    {currency.name} ({currency.code})
                                </option>
                            )}
                        </select>
                    </div>

                    <button
                        className="btn btn-primary full-width mt-3"
                        onClick={this.createOrder}
                    >
                        Créer Commande
                    </button>
                </Modal.Body>
            </Modal>
        );
    }
}

export default CreateCustomerOrderModal;